module.exports = __webpack_public_path__ + "img/rongyu3.44631449.png";